import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useGameStore = defineStore('game', () => {
  const playerCards = ref([])
  const playerStats = ref({
    wins: 0,
    losses: 0,
    rank: 'Novice',
    experience: 0
  })
  const gameState = ref('menu') // menu, playing, deck-building
  const isLoading = ref(false)

  const loadPlayerData = async () => {
    isLoading.value = true
    try {
      // API call to load player data
      console.log('Loading player data...')
    } catch (error) {
      console.error('Error loading player data:', error)
    } finally {
      isLoading.value = false
    }
  }

  const startGame = () => {
    gameState.value = 'playing'
  }

  const endGame = (result: 'win' | 'loss') => {
    if (result === 'win') {
      playerStats.value.wins++
    } else {
      playerStats.value.losses++
    }
    gameState.value = 'menu'
  }

  return {
    playerCards,
    playerStats,
    gameState,
    isLoading,
    loadPlayerData,
    startGame,
    endGame
  }
})
